"use strict";

define('rs/form/section.controller',['rs/form/abstract.form.entity', 'underscore', 'rs/form/section.view', 'rs/helper'], function (AbstractFormEntity, _, SectionView, helper) {
  var SectionController = AbstractFormEntity.extend({
    properties: ['comments', 'contentElement', 'sidebarElement', 'totalRequiredCounter', 'unsavedChanges'],
    propertiesDefinitions: ['name', 'label', 'text'],
    linksDefinitions: [],
    displayed: true,
    required: true,
    section: true,
    valid: false,
    totalRequiredCounter: 0,
    unsavedChanges: false,
    isAnswerable: true,
    initialize: function initialize(section, parent) {
      this.setDepthIndex(0);
      this._super.apply(this, arguments);
      this.startListeners();
      if (!this.isDesignerMode() && !this.getFormController().isPreviewMode()) {
        this.loadData();
        this.sync('locked');
        this.sync('unsavedChanges');
      }
    },
    checkAbsoluteValid: function checkAbsoluteValid() {
      return this._super.apply(this, arguments);
    },
    show: function show() {
      var view = this.getView();
      if (!view.isRendered()) {
        view.render();
        view.setRendered();
        this.setupChildrenViewProperties();
      }
      view.show();
    },
    hide: function hide() {
      this.getView().hide();
    },
    refreshLockedPropertyOnView: function refreshLockedPropertyOnView(locked) {
      if (locked) {
        this.getView().lock();
      } else {
        this.getView().unlock();
      }
    },
    shouldRenderFooter: function shouldRenderFooter() {
      return this.getFormController().shouldRenderFooter();
    },
    hasUnsavedChanges: function hasUnsavedChanges() {
      return !!this.getUnsavedChanges();
    },
    refreshUnsavedChangesPropertyOnView: function refreshUnsavedChangesPropertyOnView(unsaved) {
      if (unsaved) {
        this.getView().showUnsavedChangesIcon();
      } else {
        this.getView().hideUnsavedChangeIcon();
      }
    },
    lockedDidChange: function lockedDidChange(locked) {
      if (this.getFormController().isLockingEnabled()) {
        if (locked) {
          this.getView().lockSidebar();
        } else {
          this.getView().unlockSidebar();
        }
      }
    },
    lock: function lock() {
      this.set('locked', true);
    },
    isLocked: function isLocked() {
      return !!this.locked;
    },
    isExternallyLocked: function isExternallyLocked() {
      var id = this.getId();
      if (!this.getFormController().isLockingEnabled()) {
        return false;
      }
      return this.getFormController().getDocumentLock().isLockedSync(id) && !this.getFormController().getDocumentLock().isOwnedSync(id);
    },
    lockOwner: function lockOwner() {
      if (!this.getFormController().isLockingEnabled()) {
        return false;
      }
      return this.getFormController().getDocumentLock().getLockOwnerSync(this.getId());
    },
    isOwned: function isOwned() {
      if (!this.getFormController().isLockingEnabled()) {
        return false;
      }
      return this.getFormController().getDocumentLock().isOwnedSync(this.getId());
    },
    unlock: function unlock() {
      this.set('locked', false);
    },
    refreshValidity: function refreshValidity() {
      var validityObject = this.evaluateValidity(),
        validFo = validityObject.valid.length,
        requiredFo = validityObject.required.length,
        formController = this.getFormController(),
        percentage = requiredFo ? validFo * 100 / requiredFo : 100,
        valid = false;
      if (validFo == requiredFo) {
        if (this.getValue() == 'viewed' || formController.isPreviewMode()) {
          valid = true;
        }
      }
      this.setValid(valid);
      this.getView().setCompletePercentage(this.getSidebarElement(), percentage);
    },
    evaluateValidity: function evaluateValidity() {
      var requiredFoArray = [],
        validFoArray = [],
        _calculateValidity = function calculateValidity(fo) {
          var children = fo.getChildren();
          if (fo.isRequired() && fo.isVisible()) {
            requiredFoArray.push(fo);
            if (fo.isValid()) {
              validFoArray.push(fo);
            }
          }
          for (var i = 0, len = children.length; i < len; i++) {
            _calculateValidity(children[i]);
          }
        };
      _calculateValidity(this);
      return {
        valid: validFoArray,
        required: requiredFoArray
      };
    },
    refreshSectionActions: function refreshSectionActions() {
      this.getView().refreshSectionActions();
    },
    setupView: function setupView() {
      this.setView(new SectionView());
    },
    setupFormObject: function setupFormObject() {
      this._super.apply(this, arguments);
      if (!this.getFormController().isDesignerMode()) {
        this.refreshSidebar();
      }
      if (this.isExternallyLocked()) {
        this.lock();
      }
      this.refreshValidity();
    },
    startListeners: function startListeners() {
      this._super();
      if (!this.isDesignerMode()) {
        this.sync('valid');
      }
    },
    displayedDidChange: function displayedDidChange() {
      var i = 0,
        children = this.getChildren(),
        len = children.length;
      for (i = 0; i < len; ++i) {
        children[i].parentDisplayDidChange();
      }
      return this._super.apply(this, arguments);
    },
    validDidChange: function validDidChange() {
      this.getView().refreshSidebarState();
    },
    refreshSidebar: function refreshSidebar() {
      this.getView().refreshSidebarState();
    },
    getSectionController: function getSectionController() {
      return this;
    },
    requestAnswerUpdate: function requestAnswerUpdate() {
      var formController = this.getFormController();
      return this.getFormController().getDocumentModel().requestAnswerData(this.getDescendantIds()).then(function (answers) {
        formController.applyAnswerData(answers);
      });
    },
    getDescendantIds: function getDescendantIds() {
      var _processChildren = null;
      _processChildren = function processChildren(parent, data) {
        var i = 0,
          fo = null,
          children = parent.getChildren(),
          value = null,
          len = children ? children.length : 0;
        for (i = 0; i < len; ++i) {
          fo = children[i];
          if (fo.isAnswerable === true) {
            value = fo.getValue ? fo.getValue() : null;
            data.push(fo.getId());
          }
          _processChildren(fo, data);
        }
      };
      var finalData = [];
      _processChildren(this, finalData);
      return finalData;
    },
    getSectionActions: function getSectionActions() {
      return this.getFormController().getSectionActions();
    },
    isVisible: function isVisible() {
      return !!this.getDisplayed();
    },
    canHaveLinks: function canHaveLinks() {
      return false;
    },
    removeFromParent: function removeFromParent() {
      var parent = this.getParent(),
        sections = parent.getSections();
      index = sections.indexOf(this);
      if (parent.getActiveSection() == this) {
        parent.deactivateCurrentSection();
      }
      sections.splice(index, 1);
    },
    getCurrentScroll: function getCurrentScroll() {
      return this.getView().getScrollTop();
    },
    setCurrentScroll: function setCurrentScroll(scroll) {
      this.getView().setScrollTop(scroll);
    },
    formObjectValueDidChange: function formObjectValueDidChange() {
      this.setUnsavedChanges(true);
    }
  }, {
    getTypeString: function getTypeString() {
      return 'Section';
    },
    propertiesDefinitions: _.extend({}, AbstractFormEntity.propertiesDefinitions, {
      'text': {
        name: 'text',
        text: true,
        displayName: 'Title'
      },
      'label': {
        name: 'label',
        text: true,
        displayName: 'Label'
      }
    })
  });
  return SectionController;
});

